/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { difference, omit } from 'lodash';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import ExternalPicker from 'shared/ui/components/form-components/pickers/ExternalPicker.vue';

const __vue_script__ = {
    name: 'SessionSlots',

    components: {
        ExternalPicker
    },

    extends: BaseControl,

    props: {
        event: {
            type: Object,
            required: true
        },

        value: {
            type: Array,
            default: () => []
        },

        edit: {
            type: Boolean,
            default: false
        },

        model: {
            type: Object,
            required: true
        },

        options: {
            type: Object,
            default: () => null
        }
    },

    data() {
        return {
            ITEMS_PER_PAGE: 100,
            attrs: {},
            loading: false,
            processing: false,
            innerValue: [],
            documents: [],
            searchTerm: ''
        };
    },

    computed: {
        isCreation() {
            // while creating a session it does not yet have a fp_ext_id
            // so it can not be added to the track session
            return !this.model.fp_ext_id;
        }
    },

    watch: {
        $attrs: {
            immediate: true,
            handler() {
                this.attrs = omit({ ...this.$options.propsData, ...this.$attrs },
                    'edit',
                    'event',
                    'legacy',
                    'model',
                    'options',
                    'value'
                );
            }
        },
    },

    created() {
        this.loadSlots();
    },

    methods: {
        async loadSlots() {
            try {
                if (this.loading || !this.edit) {
                    return;
                }

                this.loading = true;

                const params = { parent: this.model.fp_ext_id };
                this.innerValue = await this.$services.appScripts.callAppScript(this.event._id, 'agenda-admin/slots', params);
            } catch (error) {
                const message = this.$utils.net.parseServerError(error);
                console.error('[SessionSlots] Error loading slots:', message);
            } finally {
                this.loading = false;
            }
        },

        /**
         * Loads the documents
         */
        async loadDocs() {
            try {
                if (this.loading) {
                    return;
                }

                this.loading = true;
                const results = await this.$services.documents.getDocsByType(this.event._id, 'session', {
                    search: this.searchTerm,
                    excludeIds: [...this.innerValue.map(d => d.value), this.model._id],
                    limit: this.ITEMS_PER_PAGE
                });

                this.documents = results;
            } catch (error) {
                const message = this.$utils.net.parseServerError(error);
                console.error('[SessionSlots] Could not load documents:', message);
            } finally {
                this.loading = false;
            }
        },

        /**
         * Performs the remote search
         *
         * @param {string} query the search term
         */
        search(query) {
            this.searchTerm = query;
            this.loadDocs();
        },

        async input(values) {
            if (this.processing || this.loading) {
                return;
            }

            this.processing = true;

            const currentValues = this.innerValue.map(d => d.value);
            const toAdd = difference(values, currentValues);
            const toRemove = difference(currentValues, values);

            await this.addSlots(toAdd);
            await this.removeSlots(toRemove);
            await this.loadSlots();

            this.processing = false;
        },

        async addSlots(sessionIds) {
            for (const sid of sessionIds) {
                await this.updateSlotDoc(sid, { in_slot: this.model.fp_ext_id }, 'agenda.messages.session_added_success');
            }
        },

        async removeSlots(sessionIds) {
            for (const sid of sessionIds) {
                await this.updateSlotDoc(sid, { in_slot: null }, 'agenda.messages.session_removed_success');
            }
        },

        async updateSlotDoc(sessionId, changes, message) {
            try {
                const doc = await this.$services.documents.getDocById(this.event._id, sessionId);
                const newDoc = { ...doc, ...changes };
                const node = this.$utils.workspaces.getRootNodeName(this.event);
                await this.$services.documents.updateDoc(this.event._id, node, 'session', newDoc);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t(message, [doc.name]).toString(),
                    type: 'success',
                    duration: 5000
                });
            } catch (error) {
                console.error('[SessionSlots] Could not update slot session:', error.message);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('agenda.messages.session_updated_failure').toString(),
                    type: 'error',
                    duration: 10000
                });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('external-picker',_vm._b({staticClass:"sessions-slots",attrs:{"emit-key":"_id","fp-type":"session","track-by":"_id","loading":_vm.loading,"errors":_vm.errors,"event-id":_vm.event._id,"multiple":true,"options":_vm.documents,"placeholder":_vm.$t('agenda.session.slots.placeholder'),"sortable":false,"timezone":_vm.event.timezone,"value":_vm.innerValue,"disabled":_vm.disabled || _vm.processing || _vm.isCreation},on:{"input":_vm.input,"search":_vm.search,"open":_vm.loadDocs}},'external-picker',_vm.attrs,false))}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SessionSlots.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__